import { getRuntimeConfig } from '@front/runtime-config'
import { path as registerOneSignalPath } from '@hublo/service-notification-api-types/OneSignalController/createOneSignalWhenLoggedIn'

const {
  public: { monorepoBaseUrl },
} = getRuntimeConfig()

export const registerOneSignalUrl = `${monorepoBaseUrl}${registerOneSignalPath}`
